// Toolkit Reflected — the lineage reveal in v2 language.
//
// Tate: Surface 3 reveal is "recognition-not-classification, three cases,
// editorial-serif headline on cream." No cards/boxes; quiet typographic
// groups float on cream.
//
// Cael: A2 reveal copy is LOCKED — every string sourced from the engine
// (quiz_lineage.py). Recognition first, name second.
import { useNavigate } from "react-router-dom";
import { useArc } from "../state/arc";

export default function ToolkitReflected() {
  const navigate = useNavigate();
  const { state, reset } = useArc();
  const result = state.quizResult;

  if (!result) {
    return (
      <div className="v2">
        <h2 style={{ textAlign: "center" }}>Where you land</h2>
        <p className="v2-prompt" style={{ textAlign: "center" }}>Nothing placed yet — back to the start.</p>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem" }}>
          <button className="v2-affordance" onClick={() => navigate("/welcome")}>Start over</button>
        </div>
      </div>
    );
  }

  const lin = result.lineage;
  const baseline = result.is_baseline_funnel;

  return (
    <div className="v2">
      <p className="v2-tracked-caps" style={{ textAlign: "center" }}>
        {baseline ? "Here's how you work" : "You're in good company"}
      </p>

      {/* Recognition — the actor's own instinct, surfaced first */}
      <h2
        style={{
          fontSize: "1.5rem", fontStyle: "italic", fontWeight: 300,
          textAlign: "center", margin: "1.2rem auto 2.4rem", maxWidth: "32rem",
          lineHeight: 1.35,
        }}
      >
        {lin.recognition_lead}
      </h2>

      <hr className="v2-hairline" />

      {/* The ADD — the named tradition + history */}
      <p className="v2-tracked-caps">Where it comes from</p>
      <p className="v2-prompt">
        That's <strong style={{ fontStyle: "normal", color: "var(--v2-ink)" }}>{lin.tradition_name}</strong>.
      </p>
      <p className="v2-prompt">{lin.lineage_story}</p>

      {/* The company they're in */}
      {lin.practitioners.length > 0 && (
        <>
          <hr className="v2-hairline" />
          <p className="v2-tracked-caps">
            {baseline ? "In good company" : "Working actors in it"}
          </p>
          <p className="v2-prompt">{lin.practitioners.join(", ")}.</p>
        </>
      )}

      {/* Toolkit */}
      {lin.toolkit.length > 0 && (
        <>
          <hr className="v2-hairline" />
          <p className="v2-tracked-caps">Your kit</p>
          <p className="v2-prompt" style={{ marginBottom: "1rem" }}>
            The tools you reach for in this tradition — the things you'll
            actually do with a scene.
          </p>
          {lin.toolkit.map((t) => (
            <p key={t.name} className="v2-prompt" style={{ marginTop: "0.6rem" }}>
              <strong style={{ color: "var(--v2-ink)", fontStyle: "normal" }}>{t.name}.</strong> {t.gist}
            </p>
          ))}
        </>
      )}

      <hr className="v2-hairline" />
      <p
        className="v2-prompt"
        style={{ textAlign: "center", maxWidth: "30rem", margin: "0 auto" }}
      >
        We built this from your answers. If it doesn't feel like yours, try
        again — there's no wrong place to land.
      </p>

      <div style={{ display: "flex", justifyContent: "center", gap: "3rem", marginTop: "2rem" }}>
        <button className="v2-affordance" onClick={() => navigate("/confirm")}>
          Feels like mine
        </button>
        <button
          className="v2-affordance"
          onClick={() => { reset(); navigate("/welcome"); }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
